import { useId } from "react";

/* Aetria OS official logo system.
   Mark: geometric A — left stroke slate (white when inverted), right stroke +
   4-point star follow the active brand accent via var(--brand-accent).
   Corporate Gold (#D4A017) is the default signature accent. */

const ACCENT = "var(--brand-accent, #D4A017)";
const ACCENT_INK = "var(--brand-accent-ink, #8C690C)";
const ACCENT_BRIGHT = "var(--brand-accent-bright, #D4A017)";

export const LogoMark = ({ size = 40, inverted = false }) => {
  const uid = useId().replace(/[:]/g, "");
  const leftColor = inverted ? "#FFFFFF" : "#1E293B";
  const star = (cx, cy, r, w) =>
    `M${cx} ${cy - r} Q${cx + w} ${cy - w} ${cx + r} ${cy} Q${cx + w} ${cy + w} ${cx} ${cy + r} Q${cx - w} ${cy + w} ${cx - r} ${cy} Q${cx - w} ${cy - w} ${cx} ${cy - r} Z`;
  return (
    <svg width={size} height={size} viewBox="0 0 100 100" fill="none" aria-label="Aetria OS mark">
      <defs>
        <mask id={`sc-${uid}`}>
          <rect width="100" height="100" fill="white" />
          <path d={star(46, 46, 14, 3.2)} fill="black" />
        </mask>
      </defs>
      <path d="M44 4 L58 4 L26 96 L12 96 Z" fill={leftColor} mask={`url(#sc-${uid})`} />
      <path d="M42 4 L56 4 L88 96 L74 96 Z" fill={ACCENT} />
      <path d={star(46, 46, 10, 2.4)} fill={ACCENT} />
    </svg>
  );
};

export const LogoHorizontal = ({ markSize = 30, inverted = false, className = "" }) => (
  <div className={`flex items-center gap-2.5 ${className}`} data-testid="logo-horizontal">
    <LogoMark size={markSize} inverted={inverted} />
    <span className={`font-bold tracking-tight text-xl ${inverted ? "text-white" : "text-[#1E293B]"}`}>
      AETRIA<span className="ml-1" style={{ color: inverted ? ACCENT_BRIGHT : ACCENT_INK }}>OS</span>
    </span>
  </div>
);

export const LogoFull = ({ className = "" }) => (
  <div className={`flex flex-col items-center ${className}`} data-testid="logo-full">
    <LogoMark size={88} />
    <div className="mt-5 text-4xl font-bold tracking-tight text-[#1E293B]">
      AETRIA<span className="ml-1.5" style={{ color: ACCENT_INK }}>OS</span>
    </div>
    <div className="mt-4 flex items-center gap-3 w-full justify-center">
      <span className="h-px flex-1 max-w-[64px]" style={{ background: ACCENT, opacity: 0.6 }} />
      <span className="text-[11px] font-semibold tracking-[0.24em] text-[#1E293B] whitespace-nowrap">
        AI WORKFORCE INTELLIGENCE OS
      </span>
      <span className="h-px flex-1 max-w-[64px]" style={{ background: ACCENT, opacity: 0.6 }} />
    </div>
    <p className="mt-2.5 text-[10px] tracking-[0.3em] font-medium" style={{ color: ACCENT_INK }}>
      INTELLIGENT PEOPLE. STRATEGIC FUTURES.
    </p>
  </div>
);
